export const orderInformationHover = 'order info';
export const orderInformationAlt = 'order information';
export const selectPartnerSuccessMessage = 'Added package to this service.';
